import React from "react";

import BackDrop from "../../../components/ui/BackDrop";
import { cn } from "../../../utils/twMerge";

import {
  datePickerIcon,
  closeIcon,
  fileUploadIcon,
} from "../../../assetData/icons";
import CustomDateInput from "../../../components/ui/custom-date-input/CustomDateInput";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";

const MasterBrokerAddForm = ({
  form,
  segmentName,
  addHandler,
  closeHandler,
  isButtonClicked,
}) => {
  const errors = form.formState.errors;

  const formData = new FormData();

  const onSubmit = async (data) => {
    const statusValue = form.getValues("status") === "true";
    const updatedData = { ...data, status: statusValue };

    const clonedData = { ...updatedData };

    Object.keys(clonedData).forEach((key) => {
      const uniqueKey = `${key}`;

      console.log(uniqueKey, clonedData[key]);

      if (uniqueKey !== "broker_logo") {
        formData.append(uniqueKey, clonedData[key]);
      }
    });

    formData.append(
      "broker_logo",
      data.broker_logo[0] ? data.broker_logo[0] : "",
    );

    formData.append(
      "eff_end_date",
      form.getValues("eff_end_date") !== null &&
        form.getValues("eff_end_date") !== undefined &&
        form.getValues("eff_end_date") !== ""
        ? form.getValues("eff_end_date")
        : null,
    );

    const res = await addHandler(formData);
    if (res) closeHandler();
  };

  const onClose = () => {
    closeHandler();
  };

  return (
    <>
      <div className="fixed left-1/2 top-1/2 z-50 mx-auto min-h-[300px] w-[98%] max-w-[1000px] -translate-x-1/2 rounded bg-white p-8 max-lg:top-[10%] lg:-translate-y-1/2">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">{`Add ${segmentName}`}</h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="text-s scrollbar-custom max-lg:max-h-[500px] max-lg:flex-wrap max-lg:overflow-y-scroll ">
            {/* row 1 */}
            <div className="w-full  gap-2 lg:flex">
              <div className=" w-full  gap-2 sm:flex">
                <div className={cn("flex w-full flex-col  gap-2")}>
                  <label className="text-base text-[#636363]">
                    {segmentName} Name *
                  </label>
                  <input
                    placeholder=""
                    {...form.register("name")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.name && "border-[1px] border-red-300",
                    )}
                  />
                </div>

                <div className={cn("flex w-full flex-col  gap-2 max-sm:mt-4")}>
                  <label className="text-base text-[#636363]">Short Name</label>
                  <input
                    placeholder=""
                    {...form.register("short_name")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.short_name && "border-[1px] border-red-300",
                    )}
                  />
                </div>
              </div>
              <div className=" w-full gap-2  max-lg:mt-4 sm:flex">
                <div className="flex h-full  w-full flex-col gap-2">
                  <label className="text-[#636363]">Status</label>
                  <div
                    className={cn(
                      " h-full rounded bg-neutral-100 px-2 py-[9px]",
                      errors.status && "border-[1px] border-red-300",
                    )}
                  >
                    <select
                      {...form.register("status")}
                      className=" w-full  bg-transparent px-2 text-[#636363] focus:outline-none"
                      defaultValue={true}
                    >
                      <option value={true}>Active</option>
                      <option value={false}>Inactive</option>
                    </select>
                  </div>
                </div>

                <div className="flex h-full  w-full flex-col gap-2 max-sm:mt-4">
                  <label className="text-[#636363]">API</label>
                  <div
                    className={cn(
                      " h-full rounded bg-neutral-100 px-2 py-[9px]",
                      errors.status && "border-[1px] border-red-300",
                    )}
                  >
                    <select
                      {...form.register("broker_api")}
                      className=" w-full  bg-transparent px-2 text-[#636363] focus:outline-none"
                      defaultValue={"NO"}
                    >
                      <option value={"NO"}>No</option>
                      <option value={"YES"}>Yes</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* row 2 */}
            <div className="mt-8 w-full items-end gap-2 max-lg:mt-4 lg:flex">
              <div className="w-full items-end gap-2 sm:flex">
                <div className="flex w-full items-stretch gap-4 text-neutral-600">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Upload logo</label>

                    <div className="relative flex w-full">
                      <input
                        type="file"
                        className="custom-doc-uploader bg-neutral-100 text-neutral-600"
                        {...form.register("broker_logo")}
                      />
                      <img
                        src={fileUploadIcon}
                        className="absolute left-4 top-1/2 z-10 -translate-y-1/2"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex w-full  items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Start date *</label>
                    <CustomDateInput
                      max={form.getValues("eff_end_date")}
                      initialValue={form.getValues("eff_start_date")}
                      handleSetValue={(val) => {
                        form.setValue("eff_start_date", val);
                        form.clearErrors("eff_start_date");
                      }}
                      className={cn(
                        " h-full w-full rounded bg-neutral-100 p-2 px-2 text-[#636363] focus:outline-none",
                        errors.eff_start_date && "border-[1px] border-red-300",
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="w-full items-end  gap-2 max-lg:mt-4 sm:flex">
                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>End date</label>

                    <CustomDateInput
                      min={form.getValues("eff_start_date")}
                      initialValue={form.getValues("eff_end_date")}
                      handleSetValue={(val) => {
                        form.setValue(
                          "eff_end_date",
                          val === "null" ? "None" : val,
                        );
                        form.clearErrors("eff_end_date");
                      }}
                      className={cn(
                        " h-full w-full rounded bg-neutral-100 p-2 px-2 text-[#636363] focus:outline-none",
                        errors.eff_end_date && "border-[1px] border-red-300",
                      )}
                    />
                  </div>
                </div>

                <div className={cn("flex w-full flex-col gap-2 max-sm:mt-4")}>
                  <label className="text-base text-[#636363]">Pincode *</label>
                  <input
                    placeholder="203900"
                    {...form.register("pin_code")}
                    className={cn(
                      "h-full rounded bg-neutral-100 px-2 py-2.5 text-[#636363] placeholder:italic focus:outline-none",
                      errors.pin_code && "border-[1px] border-red-300",
                    )}
                  />
                </div>
              </div>
            </div>

            {/* row 3 */}
            <div className="mt-8 w-full  items-end gap-2 max-lg:mt-4 lg:flex ">
              <div className=" w-full  items-end gap-2 sm:flex ">
                <div className={cn("flex w-full flex-col  gap-2")}>
                  <label className="text-base text-[#636363]">State *</label>
                  <input
                    placeholder="Uttar Pradesh"
                    {...form.register("state")}
                    className={cn(
                      "h-full rounded bg-neutral-100 px-2 py-2.5 text-[#636363] placeholder:italic focus:outline-none",
                      errors.state && "border-[1px] border-red-300",
                    )}
                  />
                </div>
                <div className={cn("flex w-full  flex-col gap-2  max-sm:mt-4")}>
                  <label className="text-base text-[#636363]">City *</label>
                  <input
                    placeholder="Noida"
                    {...form.register("city")}
                    className={cn(
                      "h-full rounded bg-neutral-100 px-2 py-2.5 text-[#636363] placeholder:italic focus:outline-none",
                      errors.city && "border-[1px] border-red-300",
                    )}
                  />
                </div>
              </div>

              <div className="w-full items-end gap-2 max-lg:mt-4 sm:flex ">
                <div className={cn("flex w-full flex-col  gap-2")}>
                  <label className="text-base text-[#636363]">
                    Address Line 1 *
                  </label>
                  <input
                    placeholder="Address line 1"
                    {...form.register("address_line_1")}
                    className={cn(
                      "h-full rounded bg-neutral-100 px-2 py-2.5 text-[#636363] placeholder:italic focus:outline-none",
                      errors.address_line_1 && "border-[1px] border-red-300",
                    )}
                  />
                </div>

                <div className={cn("flex w-full  flex-col gap-2  max-sm:mt-4")}>
                  <label className="text-base text-[#636363]">
                    Address Line 2
                  </label>
                  <input
                    placeholder="Address line 2"
                    {...form.register("address_line_2")}
                    className={cn(
                      "h-full rounded bg-neutral-100 px-2 py-2.5 text-[#636363] placeholder:italic focus:outline-none",
                      errors.address_line_2 && "border-[1px] border-red-300",
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-end gap-2 max-sm:justify-center md:justify-between max-lg:[&>button]:w-[50%] max-sm:[&>button]:w-full lg:[&>button]:w-1/3">
            <button
              type="submit"
              disabled={isButtonClicked}
              className={` ${
                isButtonClicked ? "opacity-[70%]" : ""
              } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-16 py-2 font-semibold text-white `}
            >
              {isButtonClicked ? <MirageLoader /> : "ADD"}
            </button>
            <button className="max-lg:hidden"></button>
            <button className="max-md:hidden"></button>
          </div>
        </form>
      </div>
      <BackDrop />
    </>
  );
};

export default MasterBrokerAddForm;
